module.exports = __webpack_public_path__ + "img/carbon-footptint-1.41a0ae0d.png";